var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracyQuoteApril(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.5 87.8",
    style: {
      enableBackground: "new 0 0 171.5 87.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AD7F2C;}\n\t.st1{fill:none;stroke:#E1CBBE;stroke-width:0.3661;stroke-miterlimit:10;}\n\t.st2{fill:#525252;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,7.4l-0.3,3.9H4.8L4.6,7.4H6z M8.4,7.4l-0.3,3.9H7.3L7,7.4H8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,6.9h0.6v11.2H18v0.5h-7.1V6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,6.9h0.8V8h-0.8V6.9z M20.5,18.7h-0.6v-8.5h0.6V18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.2,14.8l4.7-4.7h0.8l-3.6,3.5l3.9,5.1h-0.7L25.8,14l-1.6,1.5v3.1h-0.6V6.9h0.6V14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.1,14.4c0-2.6,1.5-4.4,3.7-4.4c2.2,0,3.3,1.7,3.3,4.1v0.2h-6.4v0.1c0,2.3,1.3,3.9,3.1,3.9 c1.5,0,2.4-0.9,2.6-2.1l0.6,0.1c-0.4,1.5-1.5,2.5-3.2,2.5C32.6,18.8,31.1,17,31.1,14.4z M31.7,13.8h5.8c0-1.7-0.8-3.3-2.7-3.3 C33.1,10.5,31.9,11.8,31.7,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.3,6.9h0.6v11.2h6.5v0.5h-7.1V6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,14.4c0-2.6,1.5-4.4,3.7-4.4c2.2,0,3.3,1.7,3.3,4.1v0.2h-6.4v0.1c0,2.3,1.3,3.9,3.1,3.9 c1.5,0,2.4-0.9,2.6-2.1l0.6,0.1c-0.4,1.5-1.5,2.5-3.2,2.5C53.9,18.8,52.5,17,52.5,14.4z M53.1,13.8h5.8c0-1.7-0.8-3.3-2.7-3.3 C54.5,10.5,53.3,11.8,53.1,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,21.8c-1.7,0-3.1-0.9-3.4-2.3l0.6-0.3c0.3,1.3,1.4,2.1,2.8,2.1c1.9,0,3-1,3-3.2v-1.6 c-0.5,1.2-1.6,2.1-3,2.1c-2.3,0-3.7-2-3.7-4.3c0-2.3,1.3-4.3,3.7-4.3c1.4,0,2.5,0.8,3,2.1v-1.9h0.6v7.9 C68.6,20.5,67.1,21.8,65,21.8z M65.1,10.5c-1.9,0-3.1,1.6-3.1,3.7s1.2,3.7,3.1,3.7c1.2,0,2.9-0.9,2.9-3.4V14 C68,11.4,66.3,10.5,65.1,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.7,18.8c-2.2,0-3.7-1.8-3.7-4.4s1.5-4.4,3.7-4.4c2.2,0,3.7,1.8,3.7,4.4S76.9,18.8,74.7,18.8z M74.7,18.3 c1.8,0,3.1-1.6,3.1-3.9s-1.2-3.9-3.1-3.9c-1.8,0-3.1,1.6-3.1,3.9S72.9,18.3,74.7,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.4,16.3c0.4,1.3,1.6,2,2.9,2c1.3,0,2.4-0.7,2.4-1.9c0-1.3-1-1.5-2.5-1.8c-1.5-0.4-2.8-0.6-2.8-2.2 c0-1.4,1.2-2.3,2.8-2.3c1.6,0,2.7,0.9,3,2.1l-0.5,0.2c-0.3-1-1.1-1.7-2.4-1.7c-1.3,0-2.2,0.7-2.2,1.8c0,1.1,1,1.4,2.4,1.7 c1.5,0.4,2.9,0.7,2.9,2.3c0,1.5-1.3,2.5-3,2.5c-1.5,0-3-0.7-3.4-2.3L80.4,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,27c-0.3,0-0.5-0.1-0.7-0.1c-1,0-1.6,0.7-1.6,2v0.9h2.2v0.5h-2.2v8h-0.6v-8h-1.4v-0.5h1.4v-0.9 c0-1.5,0.8-2.5,2.2-2.5c0.3,0,0.5,0,0.7,0.1V27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,38.5c-2.2,0-3.7-1.8-3.7-4.4c0-2.6,1.5-4.4,3.7-4.4c2.2,0,3.7,1.8,3.7,4.4 C24.2,36.7,22.7,38.5,20.5,38.5z M20.5,38c1.8,0,3.1-1.6,3.1-3.9s-1.2-3.9-3.1-3.9c-1.8,0-3.1,1.6-3.1,3.9S18.7,38,20.5,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,30.4c-0.2,0-0.4-0.1-0.7-0.1c-1.2,0-2.4,1.3-2.4,3.1v5h-0.6v-8.5h0.6v1.8c0.4-1,1.1-1.9,2.4-1.9 c0.2,0,0.5,0,0.6,0.1V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.3,35.6c-0.5,1.6-2,2.9-3.9,2.9c-2.9,0-5.1-2.4-5.1-6.1c0-3.6,2.2-6.1,5.1-6.1c2,0,3.6,1.1,4.2,3L44,29.6 C43.5,28,42.2,27,40.4,27c-2.7,0-4.5,2.3-4.5,5.5c0,3.2,1.8,5.5,4.5,5.5c2.3,0,3.8-1.9,3.8-4.8h-3.9v-0.5h4.5v5.7h-0.6V35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,34.1c0-2.6,1.5-4.4,3.7-4.4c2.2,0,3.3,1.7,3.3,4.1V34h-6.4v0.1c0,2.3,1.3,3.9,3.1,3.9 c1.5,0,2.4-0.9,2.6-2.1L54,36c-0.4,1.5-1.5,2.5-3.2,2.5C48.5,38.5,47.1,36.7,47.1,34.1z M47.7,33.5h5.8c0-1.7-0.8-3.3-2.7-3.3 C49.1,30.2,47.9,31.5,47.7,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,29.8h0.6v1.6c0.5-1,1.5-1.8,2.9-1.8c1.9,0,2.8,1.3,2.8,3.1v5.6h-0.6v-5.5c0-1.5-0.7-2.6-2.3-2.6 c-1.4,0-2.8,1.1-2.8,2.9v5.2h-0.6V29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,34.1c0-2.6,1.5-4.4,3.7-4.4c2.2,0,3.3,1.7,3.3,4.1V34h-6.4v0.1c0,2.3,1.3,3.9,3.1,3.9 c1.5,0,2.4-0.9,2.6-2.1l0.6,0.1c-0.4,1.5-1.5,2.5-3.2,2.5C66.7,38.5,65.2,36.7,65.2,34.1z M65.9,33.5h5.8c0-1.7-0.8-3.3-2.7-3.3 C67.2,30.2,66.1,31.5,65.9,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.4,30.4c-0.2,0-0.4-0.1-0.7-0.1c-1.2,0-2.4,1.3-2.4,3.1v5h-0.6v-8.5h0.6v1.8c0.4-1,1.1-1.9,2.4-1.9 c0.2,0,0.5,0,0.6,0.1V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.7,36.2c0-1.8,1.5-2.5,3.9-3l1.6-0.3v-0.7c0-1.3-0.8-2-2.1-2c-1.3,0-2.2,0.7-2.6,1.9l-0.6-0.2 c0.4-1.3,1.6-2.1,3.1-2.1c1.7,0,2.7,0.9,2.7,2.4v5c0,0.7,0.6,0.9,1.2,0.7v0.6c-1,0.2-1.8-0.2-1.8-1.2v-0.2 c-0.4,0.8-1.5,1.6-2.9,1.6C80.9,38.5,79.7,37.7,79.7,36.2z M85.2,33.4l-1.4,0.3c-2.2,0.4-3.5,1-3.5,2.5c0,1.1,0.8,1.8,2.1,1.8 c1.7,0,2.8-1.2,2.8-2.4V33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.3,30.3h-1.6v-0.5h1.6v-2.5h0.6v2.5h2.2v0.5h-2.2v6.1c0,1.1,0.4,1.4,1.3,1.4c0.4,0,0.7,0,1.2-0.2v0.6 c-0.4,0.1-0.7,0.2-1.2,0.2c-1.1,0-1.9-0.5-1.9-1.9V30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,26.6h0.8v1.1h-0.8V26.6z M95.1,38.4h-0.6v-8.5h0.6V38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.6,38.4l-3.3-8.5h0.6l3,7.7l3-7.7h0.6l-3.3,8.5H100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.6,34.1c0-2.6,1.5-4.4,3.7-4.4c2.2,0,3.3,1.7,3.3,4.1V34h-6.4v0.1c0,2.3,1.3,3.9,3.1,3.9 c1.5,0,2.4-0.9,2.6-2.1l0.6,0.1c-0.4,1.5-1.5,2.5-3.2,2.5C107.1,38.5,105.6,36.7,105.6,34.1z M106.2,33.5h5.8 c0-1.7-0.8-3.3-2.7-3.3C107.6,30.2,106.5,31.5,106.2,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.9,26.6l4.7,11.8h-0.6l-1.5-3.8h-5.6l-1.5,3.8h-0.6l4.7-11.8H122.9z M120,34h5.2l-2.6-6.7L120,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.3,38.4h-0.6V26.6h0.6V38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.2,27.1l-0.3,3.9H133l-0.3-3.9H134.2z M136.6,27.1l-0.3,3.9h-0.9l-0.3-3.9H136.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 63,
    className: "st1",
    width: 42.2,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 58.6,
    className: "st1",
    width: 8.5,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 58.6,
    className: "st1",
    width: 8.5,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 58.6,
    className: "st1",
    width: 8.5,
    height: 4.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.1,52.3l-0.5,3.5h-0.5l0.5-3.5h-1.3l0.1-0.5h3.2l-0.1,0.5H111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.8,53.4c-0.1,0-0.2,0-0.2,0c-0.4,0-0.8,0.3-0.9,0.9l-0.2,1.6H112l0.4-2.9h0.5l-0.1,0.5 c0.2-0.3,0.5-0.5,0.9-0.5c0.1,0,0.2,0,0.2,0L113.8,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.7,55.5c-0.2,0.2-0.5,0.4-0.9,0.4c-0.5,0-0.9-0.3-0.9-0.8c0-0.5,0.4-0.9,1.2-1l0.8-0.1l0-0.1 c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.6,0.1-0.7,0.5l-0.4-0.1c0.2-0.5,0.6-0.8,1.2-0.8c0.6,0,1,0.3,1,0.9l-0.2,1.4 c0,0.2,0.1,0.2,0.3,0.2l-0.1,0.4C116,55.9,115.7,55.7,115.7,55.5z M115.8,54.3l-0.6,0.1c-0.5,0.1-0.7,0.3-0.7,0.6 c0,0.3,0.2,0.4,0.5,0.4c0.4,0,0.8-0.3,0.8-0.6L115.8,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.2,55.4c0.4,0,0.6-0.2,0.8-0.6l0.4,0.2c-0.2,0.5-0.6,0.9-1.2,0.9c-0.7,0-1.2-0.5-1.2-1.3 c0-0.9,0.6-1.7,1.5-1.7c0.6,0,1,0.4,1.1,0.9l-0.4,0.2c-0.1-0.4-0.3-0.6-0.7-0.6c-0.6,0-1,0.6-1,1.2 C117.4,55.1,117.7,55.4,118.2,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.7,56.1c-0.2,0.5-0.5,0.7-0.9,0.7c-0.1,0-0.2,0-0.3,0l0.1-0.4c0.1,0,0.2,0,0.3,0c0.2,0,0.3-0.1,0.5-0.4 l0.2-0.3l-0.7-2.8h0.5l0.5,2.2l1.1-2.2h0.5L120.7,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.5,55.3c0.2,0,0.4,0.1,0.6,0.1c0.5,0,0.7-0.2,0.8-0.7l0.4-2.8h0.5l-0.4,2.9c-0.1,0.8-0.5,1.1-1.3,1.1 c-0.2,0-0.5,0-0.6-0.1L123.5,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.6,54.2c0,0.9-0.6,1.7-1.5,1.7c-0.7,0-1.2-0.5-1.2-1.3c0-0.9,0.6-1.7,1.5-1.7 C128.2,52.9,128.6,53.4,128.6,54.2z M128.1,54.2c0-0.6-0.3-0.9-0.7-0.9c-0.6,0-1,0.6-1,1.3c0,0.6,0.3,0.9,0.7,0.9 C127.8,55.4,128.1,54.9,128.1,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.9,53.4c-0.1,0-0.2,0-0.2,0c-0.4,0-0.8,0.3-0.9,0.9l-0.2,1.6h-0.5l0.4-2.9h0.5l-0.1,0.5 c0.2-0.3,0.5-0.5,0.9-0.5c0.1,0,0.2,0,0.2,0L130.9,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.4,52.8c0.4,0,0.7,0.2,0.9,0.5l0.2-1.5h0.5l-0.6,4H133l0.1-0.4c-0.2,0.3-0.5,0.5-0.9,0.5 c-0.7,0-1.1-0.5-1.1-1.3C131,53.7,131.6,52.8,132.4,52.8z M133.2,54.3c0.1-0.6-0.3-1-0.7-1c-0.6,0-0.9,0.6-0.9,1.3 c0,0.5,0.3,0.9,0.7,0.9c0.5,0,0.8-0.4,0.9-1L133.2,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.9,55.5c-0.2,0.2-0.5,0.4-0.9,0.4c-0.5,0-0.9-0.3-0.9-0.8c0-0.5,0.4-0.9,1.2-1l0.8-0.1l0-0.1 c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.6,0.1-0.7,0.5l-0.4-0.1c0.2-0.5,0.6-0.8,1.2-0.8c0.6,0,1,0.3,1,0.9l-0.2,1.4 c0,0.2,0.1,0.2,0.3,0.2l-0.1,0.4C136.2,55.9,136,55.7,135.9,55.5z M136.1,54.3l-0.6,0.1c-0.5,0.1-0.7,0.3-0.7,0.6 c0,0.3,0.2,0.4,0.5,0.4c0.4,0,0.8-0.3,0.8-0.6L136.1,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.6,52.9h0.5l-0.1,0.4c0.2-0.3,0.5-0.4,0.9-0.4c0.6,0,0.9,0.4,0.9,1.1l-0.3,1.9H139l0.2-1.8 c0.1-0.4-0.1-0.7-0.5-0.7c-0.4,0-0.7,0.3-0.8,0.8l-0.2,1.7h-0.5L137.6,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.3,55.1h0.6l-0.1,0.7c-0.1,0.4-0.3,0.7-0.8,0.7l0-0.3c0.3,0,0.4-0.1,0.4-0.4l0,0h-0.3L140.3,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.1,58.9c-0.9,0-1.4,0.9-1.4,1.8c0,0.8,0.5,1.3,1.1,1.3c0.5,0,0.9-0.3,1.1-0.8l0.5,0.2 c-0.3,0.7-0.9,1.1-1.6,1.1c-1,0-1.6-0.7-1.6-1.8c0-1.2,0.8-2.3,2-2.3c0.8,0,1.3,0.4,1.4,1.1l-0.5,0.1 C112,59.2,111.7,58.9,111.1,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.5,62.4l-0.8-3.2l-0.5,3.2h-0.5l0.6-4h0.7l0.7,3.3l1.7-3.3h0.7l-0.6,4h-0.5l0.5-3.2l-1.7,3.2H114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.1,60.2c0,1.2-0.8,2.3-2,2.3c-1,0-1.6-0.7-1.6-1.8c0-1.2,0.8-2.3,2-2.3C120.5,58.4,121.1,59.1,121.1,60.2z  M118.1,60.7c0,0.8,0.4,1.3,1.1,1.3c0.9,0,1.4-0.9,1.4-1.8c0-0.8-0.4-1.3-1.1-1.3C118.7,58.9,118.1,59.7,118.1,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.2,62.4c-0.1-0.1-0.2-0.2-0.3-0.4c-0.3,0.3-0.7,0.4-1.1,0.4c-0.7,0-1.1-0.5-1.1-1c0-0.5,0.3-0.9,0.7-1.1v0 c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.5,0.3-0.9,0.9-0.9c0.5,0,0.8,0.3,0.8,0.8c0,0.4-0.2,0.7-0.8,1v0c0.3,0.4,0.7,0.8,0.9,1 c0.2-0.3,0.3-0.6,0.4-1.1h0.4c-0.1,0.6-0.3,1-0.5,1.4c0.2,0.2,0.4,0.4,0.6,0.7H125.2z M124.6,61.8c-0.2-0.2-0.6-0.7-1-1.2 c-0.2,0.1-0.5,0.4-0.5,0.8c0,0.4,0.3,0.8,0.8,0.8C124.2,62.1,124.4,62,124.6,61.8z M123.5,59.5c0,0.3,0.1,0.5,0.3,0.7 c0.4-0.2,0.6-0.4,0.6-0.7c0-0.2-0.1-0.5-0.4-0.5C123.6,59,123.5,59.2,123.5,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.2,62.4l0.6-4h2.6l-0.1,0.5h-2l-0.2,1.3h1.7l-0.1,0.5H128l-0.2,1.8H127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.8,60.8c0,0.9-0.6,1.7-1.5,1.7c-0.7,0-1.2-0.5-1.2-1.3c0-0.9,0.6-1.7,1.5-1.7 C132.3,59.5,132.8,60,132.8,60.8z M132.3,60.8c0-0.6-0.3-0.9-0.7-0.9c-0.6,0-1,0.6-1,1.3c0,0.6,0.3,0.9,0.7,0.9 C131.9,62.1,132.3,61.5,132.3,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.5,62.4H135l0-0.4c-0.2,0.3-0.5,0.4-0.9,0.4c-0.6,0-0.9-0.4-0.9-1.1l0.3-1.9h0.5l-0.2,1.8 c-0.1,0.4,0.1,0.7,0.5,0.7c0.4,0,0.7-0.3,0.8-0.8l0.2-1.7h0.5L135.5,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.7,59.5h0.5l-0.1,0.4c0.2-0.3,0.5-0.4,0.9-0.4c0.6,0,0.9,0.4,0.9,1.1l-0.3,1.9h-0.5l0.2-1.8 c0.1-0.4-0.1-0.7-0.5-0.7c-0.4,0-0.7,0.3-0.8,0.8l-0.2,1.7h-0.5L136.7,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.8,59.5c0.4,0,0.7,0.2,0.9,0.5l0.2-1.5h0.5l-0.6,4h-0.5l0.1-0.4c-0.2,0.3-0.5,0.5-0.9,0.5 c-0.7,0-1.1-0.5-1.1-1.3C139.4,60.3,140,59.5,140.8,59.5z M141.6,60.9c0.1-0.6-0.3-1-0.7-1c-0.6,0-0.9,0.6-0.9,1.3 c0,0.5,0.3,0.9,0.7,0.9c0.5,0,0.8-0.4,0.9-1L141.6,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.7,61.2c0-0.9,0.6-1.7,1.5-1.7c0.8,0,1.2,0.6,1.1,1.4l0,0.1h-2.1v0.1c0,0.6,0.3,0.9,0.8,0.9 c0.4,0,0.7-0.2,0.8-0.6l0.4,0.2c-0.2,0.5-0.7,0.8-1.2,0.8C143.1,62.5,142.7,62,142.7,61.2z M143.2,60.7h1.6c0-0.5-0.2-0.8-0.7-0.8 C143.7,59.9,143.4,60.2,143.2,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.5,60c-0.1,0-0.2,0-0.2,0c-0.4,0-0.8,0.3-0.9,0.9l-0.2,1.6h-0.5l0.4-2.9h0.5l-0.1,0.5 c0.2-0.3,0.5-0.5,0.9-0.5c0.1,0,0.2,0,0.2,0L147.5,60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.9,58.5h0.6l-1.8,2.3l-0.2,1.7h-0.5l0.2-1.7l-1.1-2.3h0.6l0.9,1.8L151.9,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.7,60.9c0.7-0.5,1-0.9,1-1.3c0-0.4-0.3-0.7-0.7-0.7c-0.5,0-0.9,0.4-0.9,1c0,0.1,0,0.2,0,0.3h-0.5 c0-0.1,0-0.2,0-0.3c0-0.8,0.6-1.4,1.4-1.4c0.7,0,1.2,0.5,1.2,1.1c0,0.5-0.3,1-1.1,1.6l-1.1,0.8h2l-0.1,0.5h-2.7l0.1-0.4L153.7,60.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.8,58.5l0.9,4h-0.5l-0.2-1h-1.8l-0.6,1h-0.6l2.1-4H157.8z M156.5,60.9h1.4l-0.4-1.9L156.5,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.7,68.7c-0.2,0.2-0.5,0.4-0.9,0.4c-0.5,0-0.9-0.3-0.9-0.8c0-0.5,0.4-0.9,1.2-1l0.8-0.1l0-0.1 c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.6,0.1-0.7,0.5l-0.4-0.1c0.2-0.5,0.6-0.8,1.2-0.8c0.6,0,1,0.3,1,0.9l-0.2,1.4 c0,0.2,0.1,0.2,0.3,0.2l-0.1,0.4C111,69.1,110.8,69,110.7,68.7z M110.9,67.6l-0.6,0.1c-0.5,0.1-0.7,0.3-0.7,0.6 c0,0.3,0.2,0.4,0.5,0.4c0.4,0,0.8-0.3,0.8-0.6L110.9,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.9,67.4c0,0.9-0.6,1.7-1.4,1.7c-0.4,0-0.7-0.2-0.9-0.5l-0.1,0.5H112l0.6-4h0.5l-0.2,1.5 c0.2-0.3,0.5-0.5,0.9-0.5C114.4,66.1,114.9,66.6,114.9,67.4z M112.7,67.7c-0.1,0.6,0.3,1,0.7,1c0.6,0,0.9-0.6,0.9-1.3 c0-0.6-0.3-0.9-0.7-0.9c-0.5,0-0.8,0.4-0.9,1L112.7,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118,67.4c0,0.9-0.6,1.7-1.5,1.7c-0.7,0-1.2-0.5-1.2-1.3c0-0.9,0.6-1.7,1.5-1.7C117.5,66.1,118,66.6,118,67.4z  M117.5,67.4c0-0.6-0.3-0.9-0.7-0.9c-0.6,0-1,0.6-1,1.3c0,0.6,0.3,0.9,0.7,0.9C117.1,68.7,117.5,68.1,117.5,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.7,69.1h-0.5l0-0.4c-0.2,0.3-0.5,0.4-0.9,0.4c-0.6,0-0.9-0.4-0.9-1.1l0.3-1.9h0.5l-0.2,1.8 c-0.1,0.4,0.1,0.7,0.5,0.7c0.4,0,0.7-0.3,0.8-0.8l0.2-1.7h0.5L120.7,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.9,66.6h-0.4l0.1-0.4h0.4l0.1-0.8h0.5l-0.1,0.8h0.7l-0.1,0.4h-0.7l-0.2,1.7c0,0.2,0.1,0.4,0.4,0.4 c0.1,0,0.2,0,0.3,0l-0.1,0.4c-0.1,0-0.2,0-0.4,0c-0.6,0-0.8-0.2-0.7-0.7L121.9,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.1,65.3l-0.1,1.3h-0.3l-0.1-1.3H125.1z M125.9,65.3l-0.1,1.3h-0.3l-0.1-1.3H125.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.4,65.5c-0.9,0-1.4,0.9-1.4,1.8c0,0.8,0.5,1.3,1.1,1.3c0.5,0,0.9-0.3,1.1-0.8l0.5,0.2 c-0.3,0.7-0.9,1.1-1.6,1.1c-1,0-1.6-0.7-1.6-1.8c0-1.2,0.8-2.3,2-2.3c0.8,0,1.3,0.4,1.4,1.1l-0.5,0.1 C129.3,65.8,128.9,65.5,128.4,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.5,69.1H130l0.6-4h0.5L130.5,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.8,69.1h-0.5l0.4-2.9h0.5L131.8,69.1z M131.9,65.1h0.5l-0.1,0.6h-0.5L131.9,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.9,68.7c0.4,0,0.6-0.2,0.8-0.6l0.4,0.2c-0.2,0.5-0.6,0.9-1.2,0.9c-0.7,0-1.2-0.5-1.2-1.3 c0-0.9,0.6-1.7,1.5-1.7c0.6,0,1,0.4,1.1,0.9l-0.4,0.2c-0.1-0.4-0.3-0.6-0.7-0.6c-0.6,0-1,0.6-1,1.2 C133.2,68.4,133.5,68.7,133.9,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.3,67.5l1.4-1.3h0.6l-1.3,1.1l1,1.7h-0.6l-0.8-1.4l-0.5,0.4l-0.1,1h-0.5l0.6-4h0.5L136.3,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.2,69.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.3,0.3-0.7,0.4-1.1,0.4c-0.7,0-1.1-0.5-1.1-1c0-0.5,0.3-0.9,0.7-1.1v0 c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.5,0.3-0.9,0.9-0.9c0.5,0,0.8,0.3,0.8,0.8c0,0.4-0.2,0.7-0.8,1v0c0.3,0.4,0.7,0.8,0.9,1 c0.2-0.3,0.3-0.6,0.4-1.1h0.4c-0.1,0.6-0.3,1-0.5,1.4c0.2,0.2,0.4,0.4,0.6,0.7H142.2z M141.6,68.4c-0.2-0.2-0.6-0.7-1-1.2 c-0.2,0.1-0.5,0.4-0.5,0.8c0,0.4,0.3,0.8,0.8,0.8C141.2,68.7,141.4,68.6,141.6,68.4z M140.5,66.1c0,0.3,0.1,0.5,0.3,0.7 c0.4-0.2,0.6-0.4,0.6-0.7c0-0.2-0.1-0.5-0.4-0.5C140.6,65.6,140.5,65.9,140.5,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.7,69.1h-0.5l0.6-4h1.4c0.8,0,1.3,0.4,1.3,1.1c0,0.7-0.5,1.2-1.4,1.2h-1.1L144.7,69.1z M146,66.9 c0.6,0,0.9-0.3,0.9-0.8c0-0.4-0.3-0.6-0.8-0.6h-0.9l-0.2,1.4H146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.1,69.1h-0.5l0.6-4h0.5L148.1,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.6,68.7c-0.2,0.2-0.5,0.4-0.9,0.4c-0.5,0-0.9-0.3-0.9-0.8c0-0.5,0.4-0.9,1.2-1l0.8-0.1l0-0.1 c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.6,0.1-0.7,0.5l-0.4-0.1c0.2-0.5,0.6-0.8,1.2-0.8c0.6,0,1,0.3,1,0.9l-0.2,1.4 c0,0.2,0.1,0.2,0.3,0.2l-0.1,0.4C150.9,69.1,150.6,69,150.6,68.7z M150.7,67.6l-0.6,0.1c-0.5,0.1-0.7,0.3-0.7,0.6 c0,0.3,0.2,0.4,0.5,0.4c0.4,0,0.8-0.3,0.8-0.6L150.7,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.7,69.4c-0.2,0.5-0.5,0.7-0.9,0.7c-0.1,0-0.2,0-0.3,0l0.1-0.4c0.1,0,0.2,0,0.3,0c0.2,0,0.3-0.1,0.5-0.4 l0.2-0.3l-0.7-2.8h0.5l0.5,2.2l1.1-2.2h0.5L152.7,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.1,65.1l0.9,4h-0.5l-0.2-1h-1.8l-0.6,1h-0.6l2.1-4H158.1z M156.7,67.5h1.4l-0.4-1.9L156.7,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160,69.1h-0.5l0.6-4h0.5L160,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.4,65.3l-0.1,1.3h-0.3l-0.1-1.3H161.4z M162.3,65.3l-0.1,1.3h-0.3l-0.1-1.3H162.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.9,
    y: 53.2,
    transform: "matrix(0.8757 0.4829 -0.4829 0.8757 39.6922 -27.363)",
    className: "st1",
    width: 42.2,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 43.9,
    transform: "matrix(0.8757 0.4829 -0.4829 0.8757 30.5884 -26.7534)",
    className: "st1",
    width: 8.5,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7,
    y: 50.3,
    transform: "matrix(0.8757 0.4829 -0.4829 0.8757 35.1391 -31.5812)",
    className: "st1",
    width: 8.5,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.6,
    y: 56.9,
    transform: "matrix(0.8757 0.4829 -0.4829 0.8757 39.7877 -36.5129)",
    className: "st1",
    width: 8.5,
    height: 4.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracyQuoteApril);
export default __webpack_public_path__ + "static/media/TRACY-Quote_April.1f222d28970b503a466f9d7f616c2ea8.svg";
export { ForwardRef as ReactComponent };